/**
 * WhatsApp Channel Management Page
 * Quản lý danh sách WhatsApp sessions đã kết nối
 */
import React, { Component } from 'react';
import { Modal, Button, Spin, Tooltip, notification, Switch, Pagination, Empty, Avatar, Tag } from 'antd';
import { fetchData } from '../../../lib/apis';
import { MessageOutlined, PlusOutlined, DeleteOutlined, ReloadOutlined, DisconnectOutlined } from '@ant-design/icons';
import moment from 'moment';
import WhatsAppConnect from './WhatsAppConnect';

export default class WhatsAppChannel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            total: 0,
            loading: false,
            visibleConnect: false,
        };
        this.limit = 20;
        this.page = 1;
    }

    componentDidMount() {
        this.getListData();
    }

    getListData = async () => {
        try {
            this.setState({ loading: true });
            let res = await fetchData({ url: `api/v1/whatsapp/channels` });
            this.setState({
                listData: res.data || [],
                total: (res.data || []).length,
                loading: false
            });
        } catch (err) {
            this.setState({ loading: false });
            console.error('Error fetching WhatsApp channels:', err);
        }
    }

    disconnectChannel = async (id) => {
        Modal.confirm({
            title: 'Xác nhận ngắt kết nối',
            content: 'WhatsApp sẽ ngừng nhận và gửi tin nhắn. Bạn có thể kết nối lại sau.',
            okText: 'Ngắt kết nối',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    await fetchData({ url: 'api/v1/whatsapp/disconnect', method: 'POST', data: { channel_id: id } });
                    notification.success({ message: 'Thành công', description: 'Đã ngắt kết nối WhatsApp' });
                    this.getListData();
                } catch (err) {
                    notification.error({ message: 'Lỗi', description: err.message || 'Không thể ngắt kết nối' });
                }
            }
        });
    }

    deleteChannel = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xóa',
            content: 'Kênh WhatsApp sẽ bị xóa khỏi CRM và tài khoản sẽ đăng xuất khỏi WhatsApp để bạn có thể đăng nhập tài khoản khác.',
            okText: 'Xóa',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    await fetchData({ url: 'api/v1/whatsapp/delete', method: 'POST', data: { channel_id: id } });
                    notification.success({ message: 'Thành công', description: 'Đã xóa kênh WhatsApp và đăng xuất tài khoản' });
                    this.getListData();
                } catch (err) {
                    notification.error({ message: 'Lỗi', description: err.message || 'Không thể xóa kênh' });
                }
            }
        });
    }

    enableChannel = async (id, enable) => {
        try {
            await fetchData({
                url: `api/v1/channel/enable`,
                method: 'post',
                data: { enable: enable ? 1 : 0, ids: [id] }
            });
            notification.success({
                message: 'Thành công',
                description: enable ? 'Đã bật kích hoạt' : 'Đã tắt kích hoạt'
            });
        } catch (err) {
            notification.error({ message: 'Lỗi', description: err.message || 'Thao tác thất bại' });
        }
    }

    renderStatusTag = (item) => {
        const waStatus = item.whatsapp_config?.status;
        const channelStatus = item.status;

        if (channelStatus === 1 && waStatus === 'WORKING') return <Tag color="success">Đang hoạt động</Tag>;
        if (waStatus === 'SCAN_QR_CODE') return <Tag color="processing">Chờ quét QR</Tag>;
        if (waStatus === 'PAIRING_CODE') return <Tag color="processing">Chờ pairing code</Tag>;
        if (waStatus === 'STARTING') return <Tag color="warning">Đang khởi tạo</Tag>;
        if (waStatus === 'DISCONNECTED') return <Tag color="orange">Mất kết nối</Tag>;
        if (waStatus === 'FAILED') return <Tag color="error">Lỗi</Tag>;
        return <Tag color="default">Không hoạt động</Tag>;
    }

    renderConnectionTag = (item) => {
        const authMode = item.whatsapp_config?.auth_mode || 'qr';
        return (
            <>
                <Tag>{authMode === 'pairing_code' ? 'pairing code' : 'qr'}</Tag>
            </>
        );
    }

    render() {
        const { listData, total, loading, visibleConnect } = this.state;
        const companyId = this.props.UserLogin?.company_id || this.props.companySelected?.company_id;
        const connectTooltip = 'Tạo thêm một session WhatsApp mới cho công ty';

        return (
            <div className="list-connect content-m">
                <Modal
                    title={null}
                    visible={visibleConnect}
                    onCancel={() => this.setState({ visibleConnect: false })}
                    footer={null}
                    width={560}
                    destroyOnClose={true}
                >
                    <WhatsAppConnect
                        companyId={companyId}
                        onSuccess={() => {
                            this.setState({ visibleConnect: false });
                            this.getListData();
                        }}
                        onCancel={() => this.setState({ visibleConnect: false })}
                    />
                </Modal>

                <div className="list-c">
                    <div style={{ marginBottom: '15px' }} className="table-header">
                        <h3>
                            <MessageOutlined style={{ marginRight: 8, color: '#25D366' }} />
                            Quản lý WhatsApp: {total}
                        </h3>
                        <div className="d-flex overflow-auto" style={{ marginBottom: '15px' }}>
                            <Tooltip title={connectTooltip}>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    style={{ background: '#25D366', borderColor: '#25D366', marginRight: 8 }}
                                    onClick={() => this.setState({ visibleConnect: true })}
                                >
                                    Kết nối WhatsApp mới
                                </Button>
                            </Tooltip>
                            <Tooltip title="Làm mới">
                                <Button icon={<ReloadOutlined />} onClick={this.getListData} />
                            </Tooltip>
                        </div>
                        <div className="d-flex justify-content-end">
                            <Pagination
                                total={total}
                                showSizeChanger
                                pageSize={this.limit}
                                pageSizeOptions={[20, 50, 100]}
                                current={this.page}
                                onChange={(current, size) => {
                                    this.page = current;
                                    this.limit = size;
                                    this.getListData();
                                }}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Spin spinning={loading}>
                            {listData.length > 0 ? (
                                <table className="table table-striped table-vcenter">
                                    <thead>
                                        <tr>
                                            <th>STT</th>
                                            <th>Ảnh</th>
                                            <th>Session</th>
                                            <th>SĐT</th>
                                            <th>Kiểu liên kết</th>
                                            <th>Trạng thái</th>
                                            <th>Kích hoạt</th>
                                            <th>Ngày kết nối</th>
                                            <th className="text-right">Hành động</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listData.map((item, i) => {
                                            const stt = this.limit * (this.page - 1) + (i + 1);
                                            return (
                                                <tr key={item._id}>
                                                    <td>{stt}</td>
                                                    <td>
                                                        <Avatar src={item.avatar} icon={<MessageOutlined />} style={{ backgroundColor: '#25D366' }} />
                                                    </td>
                                                    <td>
                                                        <div>{item.whatsapp_config?.session_name || item.username}</div>
                                                        {item.whatsapp_config?.pairing_code ? (
                                                            <small style={{ color: '#666' }}>Code: {item.whatsapp_config.pairing_code}</small>
                                                        ) : null}
                                                    </td>
                                                    <td>{item.whatsapp_config?.phone_number || '-'}</td>
                                                    <td>{this.renderConnectionTag(item)}</td>
                                                    <td>{this.renderStatusTag(item)}</td>
                                                    <td>
                                                        <Switch defaultChecked={item.enable == 1} onChange={(e) => this.enableChannel(item._id, e)} />
                                                    </td>
                                                    <td>{moment(item.created_time).format('DD-MM-YYYY')}</td>
                                                    <td className="text-right">
                                                        {['WORKING', 'SCAN_QR_CODE', 'PAIRING_CODE', 'STARTING', 'DISCONNECTED'].includes(item.whatsapp_config?.status) && (
                                                            <Tooltip title="Ngắt kết nối">
                                                                <Button
                                                                    size="small"
                                                                    style={{ marginRight: 4 }}
                                                                    icon={<DisconnectOutlined />}
                                                                    onClick={() => this.disconnectChannel(item._id)}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                        <Tooltip title="Xóa">
                                                            <Button size="small" type="danger" icon={<DeleteOutlined />} onClick={() => this.deleteChannel(item._id)} />
                                                        </Tooltip>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            ) : (
                                <Empty description="Chưa có kênh WhatsApp nào được kết nối" style={{ padding: 40 }}>
                                    <Button
                                        type="primary"
                                        icon={<PlusOutlined />}
                                        style={{ background: '#25D366', borderColor: '#25D366' }}
                                        onClick={() => this.setState({ visibleConnect: true })}
                                    >
                                        Kết nối ngay
                                    </Button>
                                </Empty>
                            )}
                        </Spin>
                    </div>
                </div>
            </div>
        );
    }
}
